import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-043b28cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "system-wrap" }

import { reactive, ref, onMounted } from 'vue';
import SystemSearch from './components/SystemSearch.vue';
import SystemTable from './components/SystemTable.vue';
import { getSystemList } from '@/api/system';
import EditSystemDrawer from './components/EditSystemDrawer.vue';
import Pagination from '@/components/bussiness/Pagination/Index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// 项目管理页面
const paginationObj = reactive({
  pageNum: 1,
  pageSize: 10,
  totalCount: 0
});

// 外界缓存一份查询参数
let formData: SystemPage.SearchFormInfo = {
  name: ''
};

// 表格是否展示loading
const loading = ref(true);
// 表格数据
const tableList = ref<SystemPage.SystemListItem[]>([]);

// 添加/编辑抽屉的类型
const drawerType = ref('create');
// 是否展示抽屉
const editSystemDrawerVisible = ref(false);
// 系统的信息， 编辑回填用
const systemInfo = ref<SystemPage.SystemDrawerInfo>();

const getList = async () => {
  const { pageNum, pageSize } = paginationObj;
  const query = {
    ...formData,
    paging: {
      pageNum,
      pageSize
    }
  };
  try {
    loading.value = true;
    const res = await getSystemList(query);
    const { data } = res || {};
    tableList.value = data.systems.map((item) => {
      // 去除 createTime 可能是undefined的可能，并且移除无用的创建人id
      const { sid, sysName, sysEname, sysIcon, sysUrl, sysDesc, createTime, portalIcon } = item;
      return {
        sid,
        sysName,
        sysEname,
        portalIcon,
        sysIcon,
        sysUrl,
        sysDesc,
        createTime: createTime!
      };
    });
    paginationObj.totalCount = data.paging.totalCount;
  } catch (e) {
    console.log(e);
  }
  loading.value = false;
};

// 点击查询/重置
const onSearch = (searchData: SystemPage.SearchFormInfo) => {
  paginationObj.pageNum = 1;
  paginationObj.pageSize = 10;
  formData = { ...searchData };
  getList();
};

// 点击新建系统
const onCreate = () => {
  systemInfo.value = undefined;
  drawerType.value = 'create';
  editSystemDrawerVisible.value = true;
};

// 点击表格内编辑
const editRow = (row: SystemPage.SystemListItem) => {
  console.log('[ editRow ]-111', row);
  drawerType.value = 'edit';
  const { sid, sysName, sysEname, sysIcon, sysUrl, sysDesc, portalIcon } = row;

  systemInfo.value = {
    sid,
    sysName,
    sysEname,
    sysIcon,
    sysUrl,
    sysDesc,
    portalIcon
  };
  editSystemDrawerVisible.value = true;
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  const _component_e_button = _resolveComponent("e-button")!
  const _component_e_block = _resolveComponent("e-block")!
  const _component_EContent = _resolveComponent("EContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_EContent, { block: true }, {
        header: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_e_block, {
              title: "系统管理",
              sider: false
            }, {
              "header-right": _withCtx(() => [
                _createVNode(_component_e_button, { onClick: onCreate }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加系统")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(SystemSearch, {
              onOnSearch: onSearch,
              onOnReset: onSearch
            })
          ])
        ]),
        main: _withCtx(() => [
          _createVNode(SystemTable, {
            "table-list": tableList.value,
            loading: loading.value,
            onOnEdit: editRow,
            onUpdateTable: getList
          }, null, 8, ["table-list", "loading"]),
          _createVNode(Pagination, {
            pageNo: paginationObj.pageNum,
            "onUpdate:pageNo": _cache[0] || (_cache[0] = ($event: any) => ((paginationObj.pageNum) = $event)),
            pageSize: paginationObj.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((paginationObj.pageSize) = $event)),
            total: paginationObj.totalCount,
            onPagination: getList
          }, null, 8, ["pageNo", "pageSize", "total"])
        ]),
        _: 1
      })
    ]),
    _createVNode(EditSystemDrawer, {
      drawerVisible: editSystemDrawerVisible.value,
      "onUpdate:drawerVisible": _cache[2] || (_cache[2] = ($event: any) => ((editSystemDrawerVisible).value = $event)),
      type: drawerType.value,
      "system-info": systemInfo.value,
      onOnSuccess: getList
    }, null, 8, ["drawerVisible", "type", "system-info"])
  ], 64))
}
}

})